<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 600px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'UpLevelDayStat',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: this.title
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        {
          type: 'value',
          axisLabel: {
            formatter: '{value}%' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    refresh(data, key) {
      this.initChart()
      const time = []
      const d = {}
      const legend = []
      for (let i = 1; i <= 9; i++) {
        legend.push(`奖励${i}`)
      }
      for (const i in data) {
        const val = data[i]
        time.push(dateStrTodate(val.date))
        for (const k in val.reward_user) {
          const stat = val.reward_user[k]
          if (d[k] === undefined) {
            d[k] = []
          }
          d[k].push(stat[key])
        }
      }
      for (const i in d) {
        const val = d[i]
        const temp = {
          name: '奖励' + i,
          data: val,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          },
          itemStyle: {
            // 设置柱子宽度
            barWidth: '50%'
          }
        }
        this.option.series.push(temp)
      }

      this.option.legend.data = legend
      this.option.xAxis.data = time
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
